import React from 'react'
import Photo from '../Images/JamesNavy.jpg'

function About() {
  return (
    <div className='bg-gradient-to-b from-slate-50 to-white'>
      {/* Hero Section */}
      <div className='py-16 lg:py-24 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900'>
        <div className='max-w-4xl mx-auto px-6 lg:px-8 text-center'>
          <h1 className='hero-title mb-6'>Our journey starts with a passion to create</h1>
          <p className='text-lg md:text-xl text-slate-300 leading-relaxed max-w-3xl mx-auto'>
            From a young age, I've been driven by a deep curiosity to understand how things work.
            When I discovered software development, I realized there was an intricate world hidden in ones and zeros—a foundation upon which our entire reality is built. 
            Software is now a part of everything. 
            My goal is to allow small businesses to connect to their customers digitally through unique software solutions.
          </p>
        </div>
      </div>

      <div className='max-w-7xl mx-auto px-6 lg:px-8 py-16'>
        {/* Mission, Vision, Values Grid */}
        <div className='grid lg:grid-cols-3 gap-8 mb-16'>
          {/* Mission */}
          <div className='card p-8'>
            <div className='flex items-center gap-3 mb-6'>
              <div className='w-12 h-12 bg-gradient-to-r from-blue-500 to-cyan-500 rounded-lg flex items-center justify-center'>
                <svg className='w-6 h-6 text-white' fill='currentColor' viewBox='0 0 24 24'>
                  <path d='M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z'/>
                </svg>
              </div>
              <h2 className='text-2xl font-semibold text-slate-800'>Mission</h2>
            </div>
            <p className='text-slate-600 leading-relaxed'>
              Our mission is to create custom software solutions that support small businesses and local organizations, and to provide the best possible service and support to empower our customers to grow.
            </p>
          </div>

          {/* Vision */}
          <div className='card p-8'>
            <div className='flex items-center gap-3 mb-6'>
              <div className='w-12 h-12 bg-gradient-to-r from-purple-500 to-pink-500 rounded-lg flex items-center justify-center'>
                <svg className='w-6 h-6 text-white' fill='currentColor' viewBox='0 0 24 24'>
                  <path d='M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z'/>
                </svg>
              </div>
              <h2 className='text-2xl font-semibold text-slate-800'>Vision</h2>
            </div>
            <p className='text-slate-600 leading-relaxed'>
              Our vision is to become the go-to software development company for small businesses and local organizations in the Merrimac Valley and Southern New Hampshire.
            </p>
          </div>

          {/* Values */}
          <div className='card p-8 lg:col-span-1'>
            <div className='flex items-center gap-3 mb-6'>
              <div className='w-12 h-12 bg-gradient-to-r from-green-500 to-emerald-500 rounded-lg flex items-center justify-center'>
                <svg className='w-6 h-6 text-white' fill='currentColor' viewBox='0 0 24 24'>
                  <path d='M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z'/>
                </svg>
              </div>
              <h2 className='text-2xl font-semibold text-slate-800'>Values</h2>
            </div>
            <div className='space-y-4'>
              <div>
                <h4 className='font-semibold text-blue-600 mb-1'>Integrity</h4>
                <p className='text-sm text-slate-600 leading-relaxed'>
                  Honesty and transparency are foundational to every client relationship I build.
                </p>
              </div>
              <div>
                <h4 className='font-semibold text-blue-600 mb-1'>Quality</h4>
                <p className='text-sm text-slate-600 leading-relaxed'>
                  Delivering work that stands the test of time — never settling for "good enough."
                </p>
              </div>
              <div>
                <h4 className='font-semibold text-blue-600 mb-1'>Community</h4>
                <p className='text-sm text-slate-600 leading-relaxed'>
                  Supporting the entrepreneurs and organizations that make our neighborhoods thrive.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* About James Section */}
        <div className='card p-8 lg:p-12'>
          <div className='flex items-center gap-3 mb-8'>
            <div className='w-12 h-12 bg-gradient-to-r from-orange-500 to-red-500 rounded-lg flex items-center justify-center'>
              <svg className='w-6 h-6 text-white' fill='currentColor' viewBox='0 0 24 24'>
                <path d='M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z'/>
              </svg>
            </div>
            <h2 className='text-2xl font-semibold text-slate-800'>About James</h2>
          </div>
          
          <div className='grid lg:grid-cols-3 gap-8 items-start'>
            <div className='lg:col-span-2'>
              <p className='text-slate-600 leading-relaxed text-lg'>
                After serving as an Electronics Technician in the U.S. Navy, I relocated to Massachusetts and quickly fell in love with the rich history and culture of New England. While I've always had an interest in software development, it was during the lockdown that I truly committed to learning and growing in the field.
              </p>
              <p className='text-slate-600 leading-relaxed text-lg mt-4'>
                What began as a personal challenge quickly became a passion. I discovered that the complex tools shaping our digital world were more accessible than I had imagined. Since then, I've dedicated myself to sharing that passion with others — creating online learning resources and volunteering at a local elementary school to help children build foundational skills in technology from an early age.
              </p>
              
              <div className='flex items-center gap-4 mt-8 p-6 bg-gradient-to-r from-blue-50 to-cyan-50 rounded-lg border border-blue-100'>
                <div className='w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center flex-shrink-0'>
                  <svg className='w-4 h-4 text-white' fill='currentColor' viewBox='0 0 24 24'>
                    <path d='M9 11H7v6h2v-6zm4 0h-2v6h2v-6zm4 0h-2v6h2v-6zm2.5-5H19v2h-3V6h-1V4.5c0-.83-.67-1.5-1.5-1.5h-5c-.83 0-1.5.67-1.5 1.5V6H6v2H2.5c-.28 0-.5.22-.5.5s.22.5.5.5H3v11c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V9h.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5z'/>
                  </svg>
                </div>
                <div>
                  <p className='text-sm font-medium text-slate-700 mb-1'>Military Background</p>
                  <p className='text-sm text-slate-600'>U.S. Navy Electronics Technician with a commitment to precision and reliability</p>
                </div>
              </div>
            </div>
            
            <div className='flex justify-center lg:justify-end'>
              <div className='relative'>
                <div className='absolute inset-0 bg-gradient-to-br from-blue-400 to-purple-400 rounded-2xl blur-lg opacity-20'></div>
                <img 
                  src={Photo} 
                  alt='James Wallace' 
                  className='relative rounded-2xl shadow-lg object-cover w-64 h-80 lg:w-full lg:h-96'
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default About